import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../store/index'
// components
import RatioPopup from '../../videoEditor/components/ratioPopup/ratioPopup'
import EffectPopup from '../../videoEditor/components/effectPopup/effectPopup'
// utils
import { debounce } from 'lodash-es'
import { toast, showConfirmDialog } from '@/utils/util'
import { checkTextContent } from '@/utils/utils';

@Component({
  components: {
    RatioPopup,
    EffectPopup
  },
  watch: {
    '$route.query.timestamp': {
      handler() {
        // 获取用户会员信息
        this.getUserVipInfo()
      }
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class AIImage extends Vue {

  async mounted() {
    // 判断是否存在 token
    const token = this.$route.query.ww_token
    if (!token) {
      localStorage.removeItem('ww_token')
    }
    // 获取用户会员信息
    this.getUserVipInfo()
    // 获取生图权益
    this.getGenerateImageRight()
    // 获取风格列表
    await this.getStyleList()
    // 获取比例列表
    this.getRatioList()
    // 获取效果列表
    this.getEffectList()
    // 判断是否从生成记录列表中重新生成跳转过来
    const id = this.$route.query.id
    if (id) {
      this.getGeneratedInputContent(Number(id))
    }
    this.getLocalStorageInputContent()
    // 监听 popstate 事件
    window.addEventListener("popstate", this.onPopState)
  }

  beforeDestroy() {
    window.removeEventListener("popstate", this.onPopState)
  }

  hashStr = ''

  onPopState() {
    if (location.hash) { // 解决hash页面栈累积问题
      this.hashStr = location.hash
      history.back()
    }
  }

  /****************************** 回填表单内容 ******************************/

  /** 跳转到登录页 */
  toLoginPage() {
    localStorage.setItem('AI_image_input_content', JSON.stringify({
      text: this.text,
      activeStyleIndex: this.activeStyleIndex,
      activeRatio: this.activeRatio,
      activeEffect: this.activeEffect
    }))
    this.$redirectTo({
      url: `/pages/login/login?from=${ 'AITool' }&redirect=${ '/package-tools/pages/ai-image/ai-image' }&timestamp=${ new Date().getTime() }`
    })
  }

  /** 获取已经生成的 input 内容 */
  getGeneratedInputContent(recordId: number) {
    this.$http('getGeneratedResultApi', { recordIds: [ recordId ] })
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          const result = data[0] || {}
          // 输入内容
          let handleText = result.input?.text2ImgVO?.content || ''
          if (handleText.length > this.limitWordNum) {
            handleText = handleText.slice(0, this.limitWordNum)
          }
          this.text = handleText
          // 风格
          this.activeStyleIndex = this.handleStyleList.findIndex(item => {
            return item.nameEN === result.input?.text2ImgVO?.styleCode
          })
          // 比例
          this.activeRatio = result.input?.text2ImgVO?.scaleCode || '9:16'
          // 效果
          this.activeEffect = result.input?.text2ImgVO?.effectCode || '静态'
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /** 登录返回时获取 localStorage 存储的表单输入内容 */
  getLocalStorageInputContent() {
    const inputContent = localStorage.getItem('AI_image_input_content')
    if (inputContent) {
      const { text, activeStyleIndex, activeRatio, activeEffect } = JSON.parse(inputContent)
      this.text = text
      this.activeStyleIndex = activeStyleIndex
      this.activeRatio = activeRatio
      this.activeEffect = activeEffect
      // 清除存储的数据
      localStorage.removeItem('AI_image_input_content')
    }
  }

  /****************************** 获取用户会员信息 ******************************/

  isVip = false

  getUserVipInfo() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) return
    this.$http('queryMemberLeftRightApi')
      .then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.isVip = data.vipRightsVO.isVip
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /****************************** 获取生图权益 ******************************/

  // 生图总次数
  generateImageTotalCount = 0
  // 可使用的剩余生图次数
  generateImageLeftCount = 0

  getGenerateImageRight() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) return
    const params = {
      typeEnum: 'TEXT_IMG'
    }
    this.$http('queryGenImgLimitCountApi', params)
      .then(res => {
        const { code, data, message } = res
        if (code === 200) {
          console.log(data)
          this.generateImageLeftCount = data.leftCount
          this.generateImageTotalCount = data.totalCount
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /****************************** 文本输入 ******************************/

  text = ''

  get wordNum() {
    return this.text.trim().length
  }

  onInput() {
    if (this.wordNum === this.limitWordNum) {
      toast(`最多输入${ this.limitWordNum }字，超出部分自动截断`, 'top', 4000)
    }
  }

  onPasteText() {
    if (this.wordNum === this.limitWordNum) {
      toast(`最多输入${ this.limitWordNum }字，超出部分自动截断`, 'top', 4000)
    }
  }

  limitWordNum = 200

  /** 点击粘贴 */
  handlePasteText() {
    toast('请点击输入框，长按粘贴内容')
  }

  handleDeleteText() {
    this.text = ''
  }

  /****************************** 风格选择 ******************************/

  // 风格列表
  styleList = []

  get handleStyleList() {
    const unlockList = [], lockList = []
    this.styleList.forEach((item) => {
      if (item.nameEN !== 'green_screen') {
        if (item.authType === 1) {
          lockList.push(item)
        } else {
          unlockList.push(item)
        }
      }
    })
    return unlockList.concat(lockList)
  }

  /** 获取风格列表 */
  async getStyleList() {
    return new Promise((resolve, reject) => {
      this.$http('getStyleListApi', { pageSize: 9999 })
        .then((res) => {
          const { code, data, message } = res
          if (code === 200) {
            this.styleList = data.results
            resolve(data)
          } else {
            toast(message)
            reject()
          }
        })
        .catch((error) => {
          console.error(error)
          reject()
        })
    })
  }

  // 当前选择的风格 index
  activeStyleIndex = 0

  /** 当前选择的风格详情 */
  get activeStyleItem() {
    return this.handleStyleList[this.activeStyleIndex] || {}
  }

  /** 选择风格 */
  handleSelectStyle(item, index) {
    if (this.activeStyleIndex === index) return
    // 判断是否是仅会员可用的风格
    if (!this.isVip && item.authType === 1) {
      showConfirmDialog({
        message: '成为会员解锁视频风格',
        confirmButtonText: '前往了解',
      })
        .then(() => {
          const ww_token = localStorage.getItem('ww_token')
          if (!ww_token) {
            this.toLoginPage()
            return
          }
          this.$navigateTo({
            url: '/mine-package/pages/recharge-vip/recharge-vip'
          })
        })
      return
    }
    this.activeStyleIndex = index
  }

  /****************************** 比例选择 ******************************/

  ratioList = []

  getRatioList() {
    return new Promise((resolve, reject) => {
      this.$http('getRatioListApi')
        .then((res) => {
          const { code, data, message } = res
          if (code === 200) {
            this.ratioList = data
            resolve(data)
          } else {
            toast(message)
            reject()
          }
        })
        .catch((error) => {
          console.error(error)
          reject()
        })
    })
  }

  // 控制比例弹窗显隐
  isRatioPopupVisible = false

  /** 展示选择比例弹窗 */
  showRatioPopup() {
    this.isRatioPopupVisible = true
  }

  /** 隐藏选择比例弹窗 */
  hideRatioPopup() {
    this.isRatioPopupVisible = false
  }

  // 当前选择的比例
  activeRatio = '9:16'

  /** 选择比例回调 */
  handleRatioChange(value: string) {
    this.activeRatio = value
  }

  /****************************** 效果选择 ******************************/

  effectList = []

  getEffectList() {
    return new Promise((resolve, reject) => {
      this.$http('getEffectListApi')
        .then((res) => {
          const { code, data, message } = res
          if (code === 200) {
            this.effectList = data
            resolve(data)
          } else {
            toast(message)
            reject()
          }
        })
        .catch((error) => {
          console.error(error)
          reject()
        })
    })
  }

  // 控制效果弹窗显隐
  isEffectPopupVisible = false

  /** 展示选择效果弹窗 */
  showEffectPopup() {
    this.isEffectPopupVisible = true
  }

  /** 隐藏选择比例弹窗 */
  hideEffectPopup() {
    this.isEffectPopupVisible = false
  }

  // 当前选择的效果
  activeEffect = '静态'

  /** 选择效果回调 */
  handleEffectChange(value: string) {
    this.activeEffect = value
  }

  /****************************** 生成图片 ******************************/

  // 正在生成图片
  isGenerating = false

  /** 生成图片 */
  async handleGenerateImage() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    if (!this.generateImageLeftCount) {
      toast('暂无剩余次数')
      return
    }
    if (!this.text) {
      toast('请输入内容')
      return
    }
    if (this.isGenerating) {
      return
    }

    // 检测文案风险
    const checkRes = await checkTextContent(this, this.text);
    if (checkRes) return;

    this.debounceGenerate()
  }

  /** 防抖生成 */
  debounceGenerate = debounce(function () {
    // 设为正在生成中
    this.isGenerating = true
    // 接口请求参数
    const requestData = {
      type: 'TEXT_IMG',
      text2ImgVO: {
        content: this.text,
        styleCode: this.activeStyleItem.nameEN,
        scaleCode: this.activeRatio,
        effectCode: this.activeEffect
      },
      autoUpdateArticle: false
    }

    this.$http('generateImageApi', requestData)
      .then(res => {
        const { code, data, message } = res
        if (code === 200) {
          // 重新获取生成次数
          this.getGenerateImageRight()
          // 获取生成结果
          this.getGeneratedResult(data.id)
        } else {
          this.isGenerating = false
          toast(message)
        }
      })
      .catch((error) => {
        this.isGenerating = false
        console.error(error)
      })
  }, 500)

  /****************************** 获取生图详情 ******************************/

  // 生成结果
  generatedResult = ''

  /** 查询生成结果 */
  getGeneratedResult(recordId: number) {
    this.$http('getGeneratedResultApi', { recordIds: [ recordId ] })
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          const result = data[0] || {}
          switch(result.status) {
            // 生成中
            case 1:
              setTimeout(() => {
                this.getGeneratedResult(recordId)
              }, 3000)
              break;
            // 生成成功
            case 2:
              // 设为生成完成状态
              this.isGenerating = false
              // 生成内容
              const imageList = result?.output?.imageList || []
              if (imageList.length) {
                this.generatedResult = imageList[0] || ''
                this.$navigateTo({
                  url: `/baohuo-package/pages/picture-preview/picture-preview?imgUrl=${encodeURIComponent(this.generatedResult)}&scaleRatio=${ this.activeRatio }`,
                })
              }
              break;
            // 生成失败
            case 3:
              // 设为生成完成状态
              this.isGenerating = false
              toast('查询结果失败')
              break;
          }
        } else {
          toast(message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /****************************** 历史生成数据 ******************************/

  toHistoryPage() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    this.$navigateTo({
      url: `/package-tools/pages/ai-history/ai-history?type=${ 'TEXT_IMG' }`
    })
  }

}
